import React, { useContext } from 'react';
import { AccordionContext, useAccordionButton } from 'react-bootstrap';
import plus from '../../images/plus.svg';

const CustomToggle = ({ eventKey, callback }) => {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <img
      src={plus}
      alt="Toggle"
      style={{ width: '15px', height: '15px', cursor: 'pointer' }} // Adjust size and cursor as needed
      onClick={decoratedOnClick}
      className={`custom-toggle ${isCurrentEventKey ? 'expanded' : ''}`} // Optional: add class for expanded state
    />
  );
};

export default CustomToggle; // Ensure this is the default export
